import { createFileRoute, Link } from "@tanstack/react-router";
import { Header, Footer } from "@/components/layout";
import { Breadcrumbs } from "@/components/breadcrumbs";
import { buildMeta } from "@/lib/seo";
import { breadcrumbScript } from "@/lib/breadcrumbs";
import { Globe, ArrowRight } from "lucide-react";
import { trackAnywhereIntent } from "@/lib/analytics";
import { ANYWHERE_ORIGINS as ORIGINS } from "@/lib/anywhere-origins";

export const Route = createFileRoute("/gdziekolwiek/")({
  head: () => {
    const base = buildMeta({
      title: "Gdziekolwiek — najtańsze loty z Polski | Tanie Latanie",
      description:
        "Nie wiesz dokąd lecieć? Wybierz lotnisko wylotu i zobacz najtańsze kierunki na świecie, pogrupowane po krajach.",
      path: "/gdziekolwiek",
    });
    return {
      ...base,
      scripts: [
        ...(base.scripts ?? []),
        breadcrumbScript([
          { name: "Strona główna", path: "/" },
          { name: "Gdziekolwiek", path: "/gdziekolwiek" },
        ]),
      ],
    };
  },
  component: AnywhereHub,
});

function AnywhereHub() {
  return (
    <div className="min-h-screen">
      <Header />

      <section className="container mx-auto px-4 pt-6 pb-2">
        <Breadcrumbs
          items={[
            { name: "Strona główna", path: "/" },
            { name: "Gdziekolwiek", path: "/gdziekolwiek" },
          ]}
        />
      </section>

      <section className="container mx-auto px-4 pb-8 pt-6">
        <div className="mx-auto max-w-3xl text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full glass px-4 py-1.5 text-xs font-medium uppercase tracking-widest">
            <Globe className="h-3.5 w-3.5 text-primary" aria-hidden="true" />
            Inspiracja podróżnicza
          </div>
          <h1 className="font-display text-4xl font-bold leading-tight md:text-5xl">
            Leć <span className="text-gradient-sunset">gdziekolwiek</span>
          </h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Wybierz lotnisko wylotu — pokażemy najtańsze kierunki z całego
            świata, pogrupowane po krajach i posortowane od najtańszego.
          </p>
        </div>
      </section>

      <section className="container mx-auto max-w-4xl px-4 pb-16">
        <ul className="grid gap-3 sm:grid-cols-2 md:grid-cols-3">
          {ORIGINS.map((o) => (
            <li key={o.code}>
              <Link
                to="/gdziekolwiek/$from"
                params={{ from: o.code.toLowerCase() }}
                onClick={() => trackAnywhereIntent({ source: "hub", origin: o.code })}
                className="glass group flex items-center justify-between gap-3 rounded-xl p-4 transition-all hover:shadow-glow"
              >
                <div className="min-w-0">
                  <div className="font-display text-base font-bold group-hover:text-primary">
                    {o.label}
                  </div>
                  <div className="font-mono text-[11px] text-muted-foreground">{o.sub}</div>
                </div>
                <ArrowRight className="h-4 w-4 shrink-0 text-primary opacity-60 transition-transform group-hover:translate-x-1 group-hover:opacity-100" />
              </Link>
            </li>
          ))}
        </ul>

        <div className="glass mt-8 rounded-lg p-6 text-sm text-muted-foreground">
          <p>
            <strong className="text-foreground">Skąd te ceny?</strong> Codziennie
            sprawdzamy najtańsze loty z polskich lotnisk dla ~180 tras. Cena „od"
            to najtańsza oferta w najbliższych 30–90 dniach. Po kliknięciu kraju
            zobaczysz wszystkie miasta, a po kliknięciu miasta — aktualne terminy
            i pełną ofertę z możliwością rezerwacji.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
